"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NoFiles;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _emptyDashboard = _interopRequireDefault(require("bender-url!FileManagerImages/images/empty-dashboard.svg"));

var _Constants = require("../../Constants");

var _network = require("../../utils/network");

function getI18nPathByType(isHublVideo) {
  return "FileManagerLib.emptyBrowser." + (isHublVideo ? 'video' : 'default');
}

function NoFiles(_ref) {
  var type = _ref.type;
  var isHublVideo = type === _Constants.DrawerTypes.HUBL_VIDEO;
  var i18nKeyPath = getI18nPathByType(isHublVideo);
  return _react.default.createElement("div", {
    className: "text-center"
  }, _react.default.createElement(_UIImage.default, {
    className: "m-y-10",
    width: 180,
    src: _emptyDashboard.default,
    responsive: false
  }), _react.default.createElement("h5", null, _react.default.createElement(_FormattedMessage.default, {
    message: i18nKeyPath + ".message"
  })), _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
    message: i18nKeyPath + ".uploadHint"
  })), isHublVideo && _react.default.createElement("p", {
    className: "m-top-2"
  }, _react.default.createElement(_Small.default, {
    use: "help"
  }, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: i18nKeyPath + ".noVideos",
    options: {
      href: (0, _network.getFilesUrl)()
    }
  }))));
}

NoFiles.propTypes = {
  type: _propTypes.default.oneOf(Object.keys(_Constants.DrawerTypes))
};
module.exports = exports.default;